export default "__VITE_ASSET__eHD09fd3__"